import {Injectable} from '@angular/core';
import mixpanel from 'mixpanel-browser';
import {environment} from "../../../../environments/environment";
import {Uteis} from "../../uteis/uteis";

@Injectable({
    providedIn: 'root'
})
export class MixPanelService {

    private initialized = false;
    private isIdentified = false;
    private userId: string | null = null;

    private ensureInit() {
        if (!this.validarAmbiente()) {
            return;
        }
        if (this.initialized) return;
        mixpanel.init(environment.MIXPANEL_TOKEN, {
            debug: !environment.production,
            persistence: 'localStorage',
            track_pageview: false,
        });
        this.initialized = true;
        this.hydrateIdentity();
    }

    /** Tenta recuperar o distinct_id já salvo pelo Mixpanel (apos refresh) */
    private hydrateIdentity() {
        try {

            if (!this.validarAmbiente()) {
                return;
            }

            // se o usuário já foi identificado nesta máquina/navegador:
            const savedId = (mixpanel as any).get_distinct_id?.();
            if (savedId) {
                this.userId = String(savedId);
                this.isIdentified = true;
            }
        } catch { /* ignore */
        }
    }

    /** Chame logo após o login */
    identify(distinctId: string | number) {

        if (!this.validarAmbiente()) {
            return;
        }

        this.ensureInit();
        const id = String(distinctId);
        mixpanel.identify(id);
        this.userId = id;
        this.isIdentified = true;
    }

    /** Chame no logout */
    reset() {

        if (!this.validarAmbiente()) {
            return;
        }

        if (!this.initialized) return;
        mixpanel.reset();
        this.userId = null;
        this.isIdentified = false;
    }

    validarAmbiente(): boolean {
        if (!environment.production) {
            return false;
        }

        return true;
    }

    /** Dispara eventos apenas se identificado */
    track(event: string, props?: Record<string, any>) {

        if (!this.validarAmbiente()) {
            return;
        }

        this.ensureInit();

        // respeita opt-out (LGPD)
        if ((mixpanel as any).has_opted_out_tracking?.()) return;

        if (!this.isIdentified || !this.userId) {
            if (!environment.production) {
                console.warn('[Mixpanel] track ignorado: usuário não identificado');
            }
            return;
        }
        mixpanel.track(event, {distinct_id: this.userId, ...props});
    }

    /** Define/atualiza propriedades permanentes do usuário */
    setUserProps(props: any) {

        if (!this.validarAmbiente()) {
            return;
        }

        this.ensureInit();

        if (!this.isIdentified || !this.userId) {
            console.warn('[Mixpanel] setUserProps ignorado: usuário não identificado');
            return;
        }
        const uteis = new Uteis();
        mixpanel.people.set({
            ...props,
            $name: props.name,     // Mixpanel tem alias para nome
            $email: uteis.maskEmail(props.email) ?? '',   // Mixpanel tem alias para email
        });
    }
}
